import { render, staticRenderFns } from "./ProposalPdf.vue?vue&type=template&id=1907ac91&"
import script from "./ProposalPdf.vue?vue&type=script&lang=js&"
export * from "./ProposalPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports